import React, { useEffect } from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import FooterMenu from "./FooterMenu";
import Footer from "./Footer";
import NavBar from "./NavBar/NavBar";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { observer, inject } from "mobx-react";
import { GLTypes } from "../stores/productsStore";
import { isMobileDevice, isTabletDevice } from "../utils/device";

const LayoutContainer = styled("div")(({ theme, isMobile }) => ({
  height: "100vh",
  width: "100%",
  padding: 0,
  display: "flex",
  justifyContent: "space-grbetween",
  margin: "auto",
  textAlign: "center",
  flexDirection: "column",
  borderTop: isMobile ? "none" : `10px solid ${theme.color.red}`,
  backgroundColor: isMobile ? "#f2ecea" : "white",
}));

const Hr = styled("hr")(({ isMobile }) => ({
  border: "none",
  borderTop: "1px solid #e8e8e8",
  height: !isMobile && "20px",
  width: "100vw",
  boxShadow: "rgba(20, 20, 20, 0.7) 0px 27px 55px -26px",
  margin: 0,
  borderRadius: "0 0 30px 30px",
}));

const Layout = ({ userStore, productsStore, children }) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const location = useLocation();
  const isTablet = isTabletDevice();
  const isMobile = isMobileDevice();

  useEffect(() => {
    const fetchCart = async () => {
      const data = {
        TYPE: GLTypes.B,
        USERNAME: userStore.userDetails.USERNAME,
        CUST: userStore.userDetails.CUST,
      };
      productsStore.getCart(data);
    };
    const body = document.body;
    body.dir = i18n.dir();
    body.style.overflow = "hidden";
    if (userStore.userDetails.USERNAME && userStore.userDetails.CUST) {
      fetchCart();
    }
  }, [
    userStore.language,
    i18n,
    productsStore,
    userStore.userDetails.CUST,
    userStore.userDetails.USERNAME,
  ]);

  return (
    <LayoutContainer isMobile={isMobile || isTablet}>
      <Header isRtl={isRtl} />
      {!location.pathname.match("/register") &&
        !location.pathname.match("/registrationComplete") &&
        !location.pathname.match("/login") && <Hr isMobile={isMobile || isTablet} />}
      {!location.pathname.match("/register") &&
        !location.pathname.match("/registrationComplete") &&
        !location.pathname.match("/delivery_order") &&
        !location.pathname.match("/login") && <NavBar isRtl={isRtl} />}
      <div
        style={{
          overflow: "auto",
          maxHeight:
            isMobile || isTablet
              ? "100vh"
              : !location.pathname.match("/register") &&
                  !location.pathname.match("/registrationComplete") &&
                  !location.pathname.match("/login")
                ? "90vh"
                : "90vh",
        }}
      >
        <div>
          <main
            style={{
              margin: "0 auto",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              maxWidth: "100vw",
              minWidth: "74vw",
              paddingLeft: !isMobile && !isTablet && 20,
              paddingRight: !isMobile && !isTablet && 20,
            }}
          >
            {children}
          </main>
          <Outlet />
        </div>
        {!isMobile &&
          !isTablet &&
          !location.pathname.match("/register") &&
          !location.pathname.match("/registrationComplete") &&
          !location.pathname.match("/login") && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fmargin: `auto 0`,
                marginBottom: 0,
              }}
            >
              <FooterMenu isRtl={isRtl} />
              <Footer isRtl={isRtl} />
            </div>
          )}
      </div>
    </LayoutContainer>
  );
};

export default inject("userStore", "productsStore")(observer(Layout));
